module.exports = __webpack_public_path__ + "static/img/sec1-main-img@w.80c9c5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-main-img@w.jpg
// module id = 1KCb
// module chunks = 0